module.exports = __webpack_public_path__ + "static/img/hide.412d267a.svg";